import { InvoiceEvidenceView } from '../../../../types/entity-types';
import { BillPayFlow } from '../components/bill-pay-flows-wrapper';

// Source: https://www.notion.so/Billpay-Flow-routing-logic-1fa278491bc080b282b1d16e0c594618
export const getBillPayFlow = (evidence?: InvoiceEvidenceView): BillPayFlow => {
  const hasSuggestedBeneficiaryId = evidence?.suggestedBeneficiaryId;

  if (hasSuggestedBeneficiaryId) {
    return 'KNOWN_BENEFICIARY';
  }

  const hasIban = evidence?.paymentInformation?.iban;
  const hasSortCode = evidence?.paymentInformation?.sortCode;
  const hasAccountNo = evidence?.paymentInformation?.accountNo;

  const hasDestinationAccountDetails = hasIban || (hasAccountNo && hasSortCode);

  if (!hasSuggestedBeneficiaryId && hasDestinationAccountDetails) {
    return 'KNOWN_DESTINATION_BENEFICIARY_DOES_NOT_EXIST';
  }

  return 'UNKNOWN_BENEFICIARY';
};
